import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from 'gung-standard';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecUsersService extends UsersService {
  getDefaultUserRoles() {
    return of([
      { selected: false, id: 'ACTUATOR' },
      { selected: false, id: 'ADMIN' },
      { selected: false, id: 'SALES' },
      { selected: false, id: 'USER' },
      { selected: false, id: 'VIEW' },
      { selected: false, id: 'NOPRICE' }
    ]);
  }
}
